export const SOCKET_URL = 'wss://harvey.sofive.com/ws' //'http://localhost:8000'
export const backImageURL = 'https://app.scoreplay.io/scoreboard/image/getnew'
